import { AssistantRuntimeProvider } from '@assistant-ui/react';
import { createContext, useContext } from 'react';

import useAssistantChatController from 'components/Chat/useAssistantChatController';

const ChatRuntimeContext = createContext(null);

const useChatRuntime = () => useContext(ChatRuntimeContext);

const AssistantChatRuntime = ({
    children,
    chat,
    fileKey,
    isConnected,
    onAssistantMessageCreated,
    onMessage,
    onUserMessageCreated,
    sendMessage,
}) => {
    const { chatRuntimeContextValue, runtime } = useAssistantChatController({
        chat,
        fileKey,
        isConnected,
        onAssistantMessageCreated,
        onMessage,
        onUserMessageCreated,
        sendMessage,
    });
    return (
        <ChatRuntimeContext.Provider value={chatRuntimeContextValue}>
            <AssistantRuntimeProvider runtime={runtime}>{children}</AssistantRuntimeProvider>
        </ChatRuntimeContext.Provider>
    );
};

export { useChatRuntime };
export default AssistantChatRuntime;
